const practiceSteps = [
  {
    number: '1',
    title: 'まずルールを確認する',
    description:
      '色の意味と、ひらがな4文字を12回以内に入力する流れをゲーム情報で確認します。',
  },
  {
    number: '2',
    title: '最初の推測で情報を集める',
    description:
      '最初から正解だけを狙わず、異なるかなを含む単語で候補を広げます。',
  },
  {
    number: '3',
    title: '色とかなの手掛かりを整理する',
    description:
      '緑は位置を固定し、黄色は位置を変え、灰色は候補から外して次の入力を考えます。',
  },
  {
    number: '4',
    title: 'プレイ後に復習する',
    description:
      '成績や過去問カレンダーを確認し、分からなかった単語は関連ガイドや辞書で調べます。',
  },
]

export const GameProgressionGuide: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-700 rounded-lg p-6 border border-green-200 dark:border-green-800 mb-12">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
        📈 日本語Wordleの練習の進め方
      </h2>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
        学習期間や到達レベルを決めつけず、1回のゲームで得た手掛かりを次の復習につなげる流れです。
      </p>

      <ol className="space-y-4">
        {practiceSteps.map((step) => (
          <li
            key={step.number}
            className="flex gap-4 bg-white dark:bg-gray-800 rounded-lg p-4"
          >
            <span className="flex-none w-8 h-8 rounded-full bg-green-600 text-white flex items-center justify-center font-bold">
              {step.number}
            </span>
            <div>
              <h3 className="font-semibold text-gray-900 dark:text-white mb-1">
                {step.title}
              </h3>
              <p className="text-sm text-gray-700 dark:text-gray-300">
                {step.description}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
